module.exports = __webpack_public_path__ + "img/海棠春好_四方連續_彩稿.a77f30b9.png";